import React from "react";
import { useDispatch } from "react-redux";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import _ from "lodash";
import { editProject } from "src/thunks/clientProjects";
import toastMessages from "src/constant/toastMessages.json";
import IconLock from "src/assets/images/icon_lock.svg";
import { GetError } from "src/constant";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";

export const RevokeAppAccessForm = ({ setIsRevokeAppAccess, selectedProjectManagersRow, individualClientInfo, getAllData }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();

  /** handler functions--------------------------------------------------- **/
  const handleRevokeAppAccessModalClose = () => {
    setIsRevokeAppAccess(false);
  };

  /** Function to handle the click event for revoking app access -------------------- **/
  const handleRevokeAppAccess = async () => {
    let project = selectedProjectManagersRow || [];
    let apiData = {
      id: selectedProjectManagersRow?.id,
      clientId: individualClientInfo?.id,
      clientName: individualClientInfo?.name,
      interiorPrice: project?.interiorPrice,
      exteriorPrice: project?.exteriorPrice,
      name: project?.name,
      details: "",
      contact: "",
      address: {
        street1: selectedProjectManagersRow?.address?.street1,
        country: selectedProjectManagersRow?.address?.country,
        city: selectedProjectManagersRow?.address?.city,
        zip: selectedProjectManagersRow?.address?.zip,
      },
      users: _.map(project?.users || [], (d) => {
        return {
          email: d?.email || "",
          firstName: d?.firstName,
          middleName: d?.middleName || "",
          phoneNumber: d?.phoneNumber || "",
          lastName: d?.lastName || "",
          grantAppAccess: false,
        };
      }),
    };
    try {
      let result = await dispatch(
        editProject({
          data: apiData,
          id: selectedProjectManagersRow?.id || "",
          "isParentResourceUpdated": false,
          "GrantAppAccessTrue": true,
          "flag": false
        })
      ).unwrap();
      getAllData();
      handleRevokeAppAccessModalClose();
      if (result) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.projectAccessRevoked);
      }
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  return (
    <>
      <div>
        <div className="depot-form-header-style">
          <span className="allocate-mgnr-header-color me-2">
            REVOKE APP ACCESS
          </span>
          <span className="allocate-mgnr-subheader-color">
            {individualClientInfo?.name} / {selectedProjectManagersRow?.name}
          </span>
        </div>
        <div style={{ paddingLeft: 100, paddingRight: 100 }}>
          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="depotManagerName-style common-text-for-removeDepotManager">
              {selectedProjectManagersRow?.name}
            </span>
            <span className="common-text-for-removeDepotManager changed-color-of-revoke-app-access">
              project cannot be accessed online{" "}
            </span>
            <span className="long-text-style-unlist-depot project-name-unlist-style mb-4">
              by {individualClientInfo?.name}
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              {selectedProjectManagersRow.users.length} Project Managers will
              lose online access to this project.
            </span>
            <span className="long-text-style-unlist-depot mb-1">
              {selectedProjectManagersRow.users.length} Project Manager account
              will be de-activated. They will not be able to login{" "}
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              unless assigned to another project with active app access.
            </span>
          </div>

          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="mb-3 confirm-msg-for-removeDepotManager ">
              Are you sure you want to proceed?
            </span>
            <div className="d-flex flex-row">
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                startIcon={
                  <img
                    src={IconLeftArrow}
                    width={15}
                    height={15}
                    alt="new"
                  ></img>
                }
                onClick={handleRevokeAppAccessModalClose}
                type="submit"
              >
                No, Go Back
              </Button>

              <Button
                onClick={() => handleRevokeAppAccess()}
                variant="outlined"
                className="btn-bootstrap-submit-style ms-3"
                style={{ color: "#E94F37", borderColor: "#E94F37" }}
                startIcon={
                  <img src={IconLock} width={15} height={15} alt="new"></img>
                }
              >
                Yes, Revoke app access
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
